import type { ElementType } from 'react'
import cn from 'classnames'
import * as React from 'react'
import styles from './FormField.module.css'

interface FormFieldProps {
  as?: ElementType
  className?: string
  horizontalLabel?: boolean
  children?: React.ReactNode
}

export function FormField({ as, className, horizontalLabel, ...rest }: FormFieldProps) {
  const Component = as || 'label'
  return (
    <Component
      className={cn(styles.formField, horizontalLabel && styles.formFieldHorizontalLabel, className)}
      {...rest}
    />
  )
}

interface FormFieldLabelProps extends React.HTMLAttributes<HTMLElement> {
  as?: ElementType
}

export function FormFieldLabel({ as, className, ...rest }: FormFieldLabelProps) {
  const Component = as || 'span'
  return <Component className={cn(styles.formFieldLabel, className)} {...rest} />
}

export function FormFieldControl({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={className} {...rest} />
}

export function FormFieldMessageContainer({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(styles.messageContainer, className)} {...rest} />
}
